// extracted by mini-css-extract-plugin
export default {"productGallery":"jI-z","inQuickShop":"kI-z"};